var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AboutView',{attrs:{"publications-count":_vm.publicationsCount}})
}
var staticRenderFns = []

export { render, staticRenderFns }